const accordion = () => {
  const targets = document.querySelectorAll('.js-accordion')

  if (targets.length > 0) {
    targets.forEach((el) => {
      const btn = el.querySelector('.js-button')
      const panel = el.querySelector('.js-panel')
      const content = panel.children[0]

      btn.addEventListener('click', () => {
        if (el.classList.contains('is-open')) {
          el.classList.remove('is-open')
          panel.style.height = '0px'
        } else {
          el.classList.add('is-open')
          panel.style.height = content.clientHeight + 'px'
        }
      })
    })
  }
}

export default accordion
